export default "__VITE_ASSET__DDb2DCMP__"